var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-input"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('input',{attrs:{"id":_vm.id,"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }